export const methodologyNameMapping = {
  'Multiplexed Protein Expression Testing': 'Multiplexed Protein Expression and Host Cell Protein',
  'Wide Field': 'Widefield',
  'Super Resolution / Single Molecule - STORM': 'Super Resolution - Single Molecule STORM',
  'Super Resolution PALM': 'Super Resolution - PALM',
  'Super Resolution SIM': 'Super Resolution - SIM',
  'Super Resolution SIM²': 'Super Resolution - SIM²',
  'Super Resolution Airyscan': 'Super Resolution - Airyscan',
};

export const methodologyShortName = {
    "western-blotting": "Western Blotting",
    "multiplexed": "Multiplexed Protein Expression and Host Cell Protein",
    "multiplexed-immunoassay": "Multiplexed Immunoassay",
    "widefield": "Widefield",
    "widefield-sim": "Widefield SIM",
    "confocal": "Confocal",
    "airyscan": "Super Resolution - Airyscan",
    "sim": "Super Resolution - SIM",
    "sim2": "Super Resolution - SIM²",
    "palm": "Super Resolution - PALM",
    "storm": "Super Resolution - Single Molecule STORM",
    "control": "Control",
    "flow-cytometry": "Flow Cytometry"
}
